import * as React from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'

const NotificationCardLoading: React.FC = () => {
  return (
    <StyledWrapper className="new">
      <div className="lt-section">
        <div className="type-ico"></div>
        <div className="notification-info">
          <div className="notiinfo-title"></div>
          <div className="notiinfo-desc"></div>
          <div className="notiinfo-footer">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div className="rt-section">
        <div className="close-btn">
          <Close />
        </div>
      </div>
    </StyledWrapper>
  )
}

export default NotificationCardLoading

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  height: 96.5px;
  .lt-section {
    padding: 0px 28px;
    display: flex;
    gap: 16px;
    .type-ico {
      width: 41px;
      height: 41px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #eee;
    }
    .notification-info {
      .notiinfo-title {
        width: 100px;
        height: 15px;
        background-color: #eee;
        margin-bottom: 3px;
        border-radius: 5px;
      }
      .notiinfo-desc {
        width: 300px;
        height: 12px;
        background-color: #eee;
        margin-bottom: 3px;
        border-radius: 5px;
      }
      .notiinfo-footer {
        display: flex;
        gap: 10px;
        div {
          width: 50px;
          height: 10px;
          background-color: #eee;
          border-radius: 5px;
        }
      }
    }
  }
  .rt-section {
    padding: 0px 16px;
    .close-btn {
      display: flex;
      cursor: pointer;
      svg {
        width: 10px;
        height: 10px;
      }
    }
  }
`
